/**
 * Define What boot will use
 */

import {BootInfo} from '@/boot'
import transformers from '@/transformers'

/**
 * Booting files in src/boot folder
 */
type BootInfoLoader = (mockMode?: boolean) => Array<BootInfo | string>
export const bootInfoLoader: BootInfoLoader = (test: boolean = false) =>
{
  /**
   * This list what boot to load with options
   */
  const boots =  [
    'vue-i18n',
    'keep-ui',
    'vue-progress-bar',
    'vue-zoomer',
    'script-code-injector',
    {
      path: 'vue-telepathy',
      options: {addComponent: true},
    },
    {
      path: 'axios',
      options: {
        axiosConfig: {
          baseURL: process.env.VUE_APP_API_BASE_URL,
        },
        transformers,
      },
    },
  ]

  /**
   * Test does not need to add below
   */
  if(!test) {
    boots.push(
      'kakao',
      'element-ui',
      'middleware',
      'refresh-router',
      'axios',
      'vue-gtm',
      'sentry',
      'vwo',
    )
  }

  if(process.env.NODE_ENV !== 'production') {
    boots.push('eruda')
  }

  return boots
}
